"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _time = require("./time");

var _evtcLevels = require("../evtcLevels");

var _sharedTypes = require("./sharedTypes");

var _colors = _interopRequireDefault(require("./colors"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var Logger =
/*#__PURE__*/
function () {
  _createClass(Logger, null, [{
    key: "shouldLog",
    // TODO: when would this scenario realistically get hit?
    value: function shouldLog(evtc) {
      if (!evtc) {
        return false;
      }

      var evtcLevels = (0, _evtcLevels.getEvtcLevels)();
      var evtcLogLevel = _sharedTypes.Level[evtcLevels[evtc]] || _sharedTypes.Level.TRACE;
      return evtcLogLevel <= _sharedTypes.Level.DEBUG;
    }
  }]);

  function Logger() {
    var _this = this;

    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
      transports: []
    };

    _classCallCheck(this, Logger);

    this.safelyLogMessage = function () {
      var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      try {
        var parsedObject = JSON.parse(message);
        return Object.keys(parsedObject).map(function (key) {
          return ["".concat(key, "=").concat(parsedObject[key])];
        }).join(_this.delimiter);
      } catch (_) {
        return message;
      }
    };

    if (!options.transports) {
      throw new Error('You must provide at least one transport');
    }

    this.setOptions(options);
    this.transports = options.transports || [];
    this.delimiter = ' -- ';
  }

  _createClass(Logger, [{
    key: "getDate",
    value: function getDate() {
      return (0, _time.formatDate)((0, _time.convertToMountainTime)(new Date()));
    }
  }, {
    key: "setOptions",
    value: function setOptions() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        transports: []
      };
      this.sessionId = options.sessionId;
      this.pageId = options.pageId;
      this.requestId = options.requestId;
      this.userType = options.userType;
    }
  }, {
    key: "log",
    value: function log(style, level, evtc, message) {
      if (!Logger.shouldLog(evtc)) {
        return;
      }

      var logDetails = this.getLogDetails();
      var logData = [this.getDate(), "LEVEL=".concat(_sharedTypes.Level[level]), "EVTC=".concat(evtc)].concat(_toConsumableArray(logDetails), [this.safelyLogMessage(message)]);
      var log = "".concat(style).concat(logData.join(this.delimiter)).concat(_colors.default.reset, "\n");
      this.sendLog(log);
      return log;
    }
  }, {
    key: "sendLog",
    value: function sendLog(log) {
      if (Array.isArray(this.transports)) {
        this.transports.forEach(function (transport) {
          return transport(log);
        });
      } else {
        this.transports(log);
      }
    }
  }, {
    key: "getLogDetails",
    value: function getLogDetails() {
      var chunks = [];
      if (this.sessionId) chunks.push(['SESSION_ID', this.sessionId]);
      if (this.pageId) chunks.push(['PAGE_ID', this.pageId]);
      if (this.requestId) chunks.push(['REQUEST_ID', this.requestId]);
      if (this.userType) chunks.push(['USER_TYPE', this.userType]);
      return chunks.map(function (chunk) {
        return chunk.join('=');
      });
    }
  }, {
    key: "update",
    value: function update(options) {
      this.setOptions(options);
    }
  }, {
    key: "debug",
    value: function debug(evtc, message) {
      return this.log(Logger.styles.blue, _sharedTypes.Level.DEBUG, evtc, message);
    }
  }, {
    key: "trace",
    value: function trace(evtc, message) {
      return this.log(Logger.styles.magenta, _sharedTypes.Level.TRACE, evtc, message);
    }
  }, {
    key: "info",
    value: function info(evtc, message) {
      return this.log(Logger.styles.cyan, _sharedTypes.Level.INFO, evtc, message);
    }
  }, {
    key: "warn",
    value: function warn(evtc, message) {
      return this.log(Logger.styles.yellow, _sharedTypes.Level.WARN, evtc, message);
    }
  }, {
    key: "error",
    value: function error(evtc, message) {
      return this.log(Logger.styles.red, _sharedTypes.Level.ERROR, evtc, message);
    }
  }, {
    key: "fatal",
    value: function fatal(evtc, message) {
      return this.log(Logger.styles.underline, _sharedTypes.Level.FATAL, evtc, message);
    }
  }]);

  return Logger;
}();

exports.default = Logger;
Logger.styles = {
  underline: _colors.default.underline,
  yellow: _colors.default.yellow,
  cyan: _colors.default.cyan,
  red: _colors.default.red,
  blue: _colors.default.blue,
  magenta: _colors.default.magenta
};